"use strict";

angular.module("vendor")
.controller("InvoiceListController", function(
    $scope, $timeout, $state, $stateParams, gettextCatalog, FlashBag, $resource, ModalService, StateExtensionService,
    InvoiceService, VendorInvoiceService, InvoiceStatusFilterService
) {
    $scope.service = VendorInvoiceService;
    $scope.invoiceService = InvoiceService;
    $scope.statusFilterService = InvoiceStatusFilterService;
});



//////////////////
// WEBPACK FOOTER
// ./vendor/sections/invoice/invoice-list.controller.js
// module id = 1017
// module chunks = 0